import { render, staticRenderFns } from "./WorktimeHistoryButton.vue?vue&type=template&id=71452a5d"
import script from "./WorktimeHistoryButton.vue?vue&type=script&lang=js"
export * from "./WorktimeHistoryButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports